var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "Field__Component FieldPlanTaskDuration",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      !_vm.isEditing
        ? _c(
            "b-tooltip",
            {
              attrs: {
                label: _vm.tooltip,
                position: "is-left",
                multilined: "",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "dur-display",
                  class: {
                    "is-overridden": _vm.isOverridden,
                    "is-saving": _vm.isSaving,
                  },
                  attrs: { type: "button", disabled: _vm.isSaving },
                  on: { click: _vm.startEdit },
                },
                [
                  _c("span", { staticClass: "num" }, [
                    _vm._v(
                      _vm._s(
                        _vm.resolvedMinutes == null ? "—" : _vm.resolvedMinutes
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "unit" }, [_vm._v("דק'")]),
                  _vm.isOverridden
                    ? _c("span", { staticClass: "badge" }, [_vm._v("מותאם")])
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _c("div", { staticClass: "dur-edit" }, [
            _c("div", { staticClass: "dur-edit-row" }, [
              _c("input", {
                ref: "input",
                staticClass: "dur-input",
                class: { "is-invalid": !!_vm.invalid },
                attrs: {
                  type: "number",
                  min: "1",
                  step: "1",
                  disabled: _vm.isSaving,
                },
                domProps: { value: _vm.draft },
                on: {
                  input: function ($event) {
                    _vm.draft = $event.target.value
                  },
                  blur: _vm.onBlur,
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return $event.target.blur()
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    )
                      return null
                    return _vm.cancel.apply(null, arguments)
                  },
                },
              }),
              _c("span", { staticClass: "dur-unit" }, [_vm._v("דק'")]),
            ]),
            _c(
              "p",
              { staticClass: "dur-bank" },
              [
                _vm.bankMinutes == null
                  ? [_vm._v("ריק = משך מבנק המשימות")]
                  : [
                      _vm._v(
                        "ריק = " + _vm._s(_vm.bankMinutes) + " דק' מבנק המשימות"
                      ),
                    ],
              ],
              2
            ),
            _vm.invalid
              ? _c("p", { staticClass: "dur-error" }, [
                  _vm._v(_vm._s(_vm.invalid)),
                ])
              : _vm._e(),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }